import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Header from '../../components/header/AdminHeader'
import Footer from '../../components/footer/Footer'
import { Accordion } from 'react-bootstrap-accordion'
import searchItemsData from '../../assets/fake-data/data-search-items'
import useAdminItemStore from '../../stores/admin/itemStore'
import ChangeImageModal from '../../components/layouts/ChangeImageModal'

const AdminItems = () => {
    const { fetchItems, items } = useAdminItemStore()
    const [visible, setVisible] = useState(10)
    const [filters, setFilters] = useState({
        Public: ['Yes', 'No'],
        Popular: ['Yes', 'No'],
        Status: ['Available', 'Locked'],
        Tags: ['Any'],
        Phase: ['Any'],
    })
    const [modalItem, setModalItem] = useState(null)
    const [modalShow, setModalShow] = useState(false)
    const [filteredItems, setFilteredItems] = useState([])

    const handleOpenModal = (item) => {
        setModalShow(true)
        setModalItem(item)
    }

    useEffect(() => {
        fetchItems()
    }, [fetchItems])

    useEffect(() => {
        setFilteredItems(applyFilters(items))
    }, [items])

    useEffect(() => {
        setVisible(10)
        setFilteredItems(applyFilters(items))
    }, [filters, items])

    const showMoreItems = () => {
        setVisible((prevValue) => prevValue + 3)
    }

    const handleFilterChange = (category, field) => {
        const updatedFilters = { ...filters }
        const isSelected = updatedFilters[category].includes(field)

        if (isSelected) {
            updatedFilters[category] = updatedFilters[category].filter((item) => item !== field)
        } else {
            updatedFilters[category] = [...updatedFilters[category], field]
        }

        setFilters(updatedFilters)
    }

    const applyFilters = (items) => {
        let filteredItems = [...items]

        searchItemsData.forEach((category) => {
            const selectedFilters = filters[category.title]

            if (selectedFilters && selectedFilters.length > 0) {
                switch (category.title) {
                    case 'Public':
                        filteredItems = filteredItems.filter((item) =>
                            selectedFilters.includes(item.is_public ? 'Yes' : 'No'),
                        )
                        break
                    case 'Popular':
                        filteredItems = filteredItems.filter((item) =>
                            selectedFilters.includes(item.is_popular ? 'Yes' : 'No'),
                        )
                        break
                    case 'Status':
                        filteredItems = filteredItems.filter((item) =>
                            selectedFilters.includes(item.is_available ? 'Available' : 'Locked'),
                        )
                        break
                    case 'Tags':
                        if (!selectedFilters.includes('Any')) {
                            filteredItems = filteredItems.filter((item) => selectedFilters.includes(item.exterior))
                        }
                        break
                    case 'Phase':
                        if (!selectedFilters.includes('Any')) {
                            filteredItems = filteredItems.filter((item) => selectedFilters.includes(item.phase))
                        }
                        break
                    default:
                        break
                }
            }
        })

        return filteredItems
    }

    return (
        <div>
            <Header />
            <section className="tf-section-admin tf-rank">
                <div className="container-fluid">
                    <h2 class="tf-title-heading ct style-2 fs-30 mg-bt-10">Quản lý vật phẩm</h2>
                    <div className="row">
                        <div className="col-xl-2 col-lg-2 col-md-12">
                            <div id="side-bar" className="side-bar style-3">
                                {searchItemsData.map((item, index) => (
                                    <div className="widget widget-category mgbt-24 boder-bt" key={index}>
                                        <div className="content-wg-category">
                                            <Accordion title={item.title} show={true}>
                                                <form action="#">
                                                    {item.content.map((option, idx) => (
                                                        <div key={idx}>
                                                            <label>
                                                                {option.field}
                                                                <input
                                                                    type="checkbox"
                                                                    checked={filters[item.title].includes(option.field)}
                                                                    onChange={() =>
                                                                        handleFilterChange(item.title, option.field)
                                                                    }
                                                                />
                                                                <span className="btn-checkbox"></span>
                                                            </label>
                                                            <br />
                                                        </div>
                                                    ))}
                                                </form>
                                            </Accordion>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="col-xl-10 col-lg-10 col-md-12">
                            <div className="table-ranking">
                                <div className="flex th-title">
                                    <div className="column1">
                                        <h3>{filteredItems.length} items</h3>
                                    </div>
                                    <div className="column">
                                        <h5>Float</h5>
                                    </div>
                                    <div className="column">
                                        <h5>Phase</h5>
                                    </div>
                                    <div className="column">
                                        <h5>Buff Price</h5>
                                    </div>
                                    <div className="column">
                                        <h5>Price</h5>
                                    </div>
                                    <div className="column">
                                        <h5>Manual Update</h5>
                                    </div>
                                    <div className="column">
                                        <h5>Popular</h5>
                                    </div>
                                    <div className="column">
                                        <h5>New Listed</h5>
                                    </div>
                                    <div className="column">
                                        <h5>Status</h5>
                                    </div>
                                </div>
                                {filteredItems.length > 0 ? (
                                    filteredItems.slice(0, visible).map((item, idx) => (
                                        <div key={idx} className="fl-item2">
                                            <div className="item flex">
                                                <div className="infor-item flex column1">
                                                    <div className="media">
                                                        {item.images[0] ? (
                                                            <img src={item.images[0].url} alt={item.name} />
                                                        ) : (
                                                            ''
                                                        )}

                                                        <div className="change-image">
                                                            <Link
                                                                to="#"
                                                                onClick={() => handleOpenModal(item)}
                                                                className="change-image-btn"
                                                            >
                                                                <span>Thay ảnh</span>
                                                            </Link>
                                                        </div>
                                                    </div>
                                                    <div className="content-collection pad-t-4">
                                                        <h6 className="title mb-15">
                                                            {item.name}
                                                            <br />
                                                        </h6>
                                                        <div className="author flex">
                                                            <div className="content">
                                                                <h6>{item.is_public}</h6>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="column td2">
                                                    <span>{item.float_num}</span>
                                                </div>
                                                <div className="column td3">
                                                    <span>{item.phase}</span>
                                                </div>
                                                <div className="column td4">
                                                    <span>{item.price}</span>
                                                </div>
                                                <div className="column td4">
                                                    <span>{item.price}</span>
                                                </div>
                                                <div className="column td5">
                                                    <span>Yes</span>
                                                </div>
                                                <div className="column td5">
                                                    <span>{item.is_popular ? 'Yes' : 'No'}</span>
                                                </div>
                                                <div className="column td5">
                                                    <span>{item.is_popular ? 'Yes' : 'No'}</span>
                                                </div>
                                                <div className="column td6">
                                                    <span>{item.is_available ? 'Available' : 'Locked'}</span>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="no-items-found">
                                        <p>No items found.</p>
                                    </div>
                                )}
                                {visible < filteredItems.length && (
                                    <div className="col-md-12 wrap-inner load-more text-center">
                                        <Link
                                            to="#"
                                            id="load-more"
                                            className="sc-button loadmore fl-button pri-3"
                                            onClick={showMoreItems}
                                        >
                                            <span>Load More</span>
                                        </Link>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <ChangeImageModal
                show={modalShow}
                onHide={() => {
                    setModalShow(false)
                    setModalItem(null)
                }}
                item={modalItem}
                onSuccess={() => {
                    setModalShow(false)
                    setModalItem(null)
                    fetchItems()
                }}
            />
        </div>
    )
}

export default AdminItems
